<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
				</div>
				<div class="modal-body">
					<iframe ref="iframe" id="iframe" src="" width="100%" height="500px"></iframe>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import swal from "sweetalert2";
import Ladda from "ladda";
import Vuetable from "vuetable-2/src/components/Vuetable";

export default {
  props: ["user", "isAuth", "data"],
  components: {
    datatable: Vuetable
  },
  data() {
    return {
      modal: {
        selector: "modal-budget-print-simple-pdf"
      },

      url:
        this.$env.ROOT +
        "/" +
        this.$i18n.locale +
        "/" +
        this.$platform.slug +
        "/pdf/viewer",

      options: {
        height: "500px"
      }
    };
  },
  methods: {
    open() {
      var modal = $("#" + this.modal.selector);
      modal.modal("show");

      this.embed();
    },
    close() {
      var modal = $("#" + this.modal.selector);
      modal.modal("hide");
    },
    embed() {
      var iframe = document.getElementById("iframe");
      iframe.src =
        this.url +
        "?file=" +
        this.$env.ROOT +
        "/" +
        this.$lang.getLang() +
        "/" +
        this.$platform.slug +
        "/management/budgets/" +
        this.data.random +
        "/pdf/simple";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/management/budgets/views/Print.vue